import React from "react";
import './Motercycle.css'
import Navbar from "../component/navbar/nav";
import Footer from "../component/navbar/footer";
const Motercycle = ()=>{
return(
    <div className="Motercycle-home-container">
        <div  className="Nav-bar">
        <Navbar/>
        </div>
       
        <div className="Bike-model-nav">
            <ul>
                <li>pulse</li>
                <li>bullet</li>
                <li>rx</li>
            </ul>
        </div>
        <div className="Footer">
    {/* Footer */}
    <Footer />
        </div>

  </div>
)
}
export default Motercycle;